import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import Icon from '@scramble/design-system/icons/check-verified-02.svg';
import { DashboardBonusCard } from '@/pages/DashboardPage/components/DashboardBonusCard';

export const BonusForVerification = ({ data }) => {
  const { openSingleModal } = useModal();
  const { t } = useTranslation();

  const onLearnMore = () => {
    openSingleModal(MODAL_IDS.verification_bonus_info_modal);
  };

  return (
    <DashboardBonusCard
      title={data?.title}
      text={data?.desc}
      icon={<img src={Icon} alt="icon" width={24} height={24} />}
      footer={
        <button type="button" onClick={onLearnMore}>
          {t('affiliate:increased_income.learn_more')}
        </button>
      }
    />
  );
};
